module.exports = __webpack_public_path__ + "static/img/qualifications_icon_05.5cfd8b4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/about/qualifications_icon_05.png
// module id = jIfS
// module chunks = 3